import styled from "styled-components";

export default function OrderInvoiceTop({ children }) {
  return (
    <Block>{children}</Block>
  )
}

const Block = styled.div`
  padding-left: calc(100vw * (17 / 375));
  padding-right: calc(100vw * (17 / 375));
  border-bottom: calc(100vw * (12 / 375)) solid #F7F7F7;
`;